'use strict';

exports.__esModule = true;
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _survey = require('redux/modules/survey');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Providers = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    providers: state.survey.providers,
    survey: state.survey.data
  };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ loadProviders: _survey.loadProviders }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Providers, _Component);

  function Providers(props) {
    (0, _classCallCheck3.default)(this, Providers);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.styles = require('./Providers.scss');
    _this.state = {
      height: window.innerHeight || document.documentElement.clientHeight,
      width: window.innerWidth || document.documentElement.clientWidth,
      device_type: (window.innerWidth || document.documentElement.clientWidth) < 992 ? 'mobile' : 'desktop',
      default_lang: _this.props.survey.languages.en ? 'en' : (0, _keys2.default)(_this.props.survey.languages)[0],
      selected_provider: _this.props.selectedProvider
    };
    return _this;
  }

  Providers.prototype.componentWillMount = function componentWillMount() {
    this.props.loadProviders();
  };

  Providers.prototype.componentDidMount = function componentDidMount() {
    console.log(this.props.providers);
  };

  Providers.prototype.setProvider = function setProvider(provider) {
    this.setState({ selected_provider: provider.id });
    this.props.onSelectProvider(provider);
  };

  Providers.prototype.getSingleProvider = function getSingleProvider(provider) {
    return _react2.default.createElement(
      _Col2.default,
      { xs: 12, sm: 4, md: 4, lg: 4 },
      _react2.default.createElement(
        'div',
        { className: this.state.selected_provider === provider.id ? this.styles.provider_container + ' ' + this.styles.provider_selected : this.styles.provider_container, onClick: this.setProvider.bind(this, provider) },
        _react2.default.createElement(
          'div',
          { className: this.styles.provider_name },
          provider.name
        ),
        _react2.default.createElement(
          'div',
          { className: this.styles.provider_address },
          provider.address
        )
      )
    );
  };

  Providers.prototype.getProviders = function getProviders() {
    var _this2 = this;

    var providers = this.props.providers;

    var providerElem = [];
    if (providers && providers.length) {
      providers.map(function (item) {
        providerElem.push(_this2.getSingleProvider(item));
      });
    }
    return providerElem;
  };

  Providers.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: this.styles.providers_page_container, style: { height: this.state.height, width: this.state.width } },
        _react2.default.createElement(
          _Grid2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: this.styles.provider_wrapper },
            _react2.default.createElement(
              _Row2.default,
              { className: this.styles.provider_header_container },
              _react2.default.createElement(
                _Col2.default,
                { xs: 12, sm: 12, md: 12, lg: 12 },
                _react2.default.createElement(
                  'span',
                  { className: this.styles.provider_heading },
                  'Please select a provider'
                )
              )
            ),
            _react2.default.createElement(
              _Row2.default,
              { className: this.styles.provider_list_container },
              this.getProviders()
            )
          )
        )
      )
    );
  };

  return Providers;
}(_react.Component), _class2.propTypes = {
  loadProviders: _react.PropTypes.func,
  onSelectProvider: _react.PropTypes.func,

  providers: _react.PropTypes.object,
  survey: _react.PropTypes.object,
  theme: _react.PropTypes.object,

  selectedProvider: _react.PropTypes.number
}, _temp)) || _class);
exports.default = Providers;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Providers/Providers.js
// module id = 2332
// module chunks = 0